import { QueryResource, QueryResourcesInfinite } from 'datx-jsonapi-react';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

import { DEFAULT_LECTURE_INFINITE_SORT } from '@/queries/thin-lectures';
import { OmnisearchFilterItem } from '@/resources/OmnisearchFilterItem';
import { OmnisearchLecturesFilter } from '@/resources/OmnisearchLecturesFilter';
import { OmnisearchThinLecture } from '@/resources/OmnisearchThinLecture';

interface IQueryLecturesByQueryInfiniteProps {
  filters: Record<string, string | Array<string>>;
  sort?: string;
  pageSize?: number;
}

export const queryOmnisearchLectureInfinite = ({
  filters,
  sort = DEFAULT_LECTURE_INFINITE_SORT,
  pageSize = 16,
}: IQueryLecturesByQueryInfiniteProps): QueryResourcesInfinite<OmnisearchThinLecture> => {
  return (pageIndex) => {
    const pageNumber = pageIndex + 1;

    return [
      OmnisearchThinLecture.type,
      {
        filter: {
          scope: 'all',
          ...omitBy(filters, isNil),
        },
        sort: [sort],
        include: ['sorted_profiles', 'event_session', 'tag', 'lecture_access_permission'],
        params: [
          {
            key: 'page[size]',
            value: pageSize.toString(),
          },
          {
            key: 'page[number]',
            value: pageNumber.toString(),
          },
        ],
      },
    ];
  };
};

export const queryOmnisearchThinLectureFiltersRelationship = (
  filters: Record<string, string | Array<string>>
): QueryResource<OmnisearchLecturesFilter> => {
  return [
    OmnisearchLecturesFilter.type,
    'filters',
    {
      filter: {
        scope: 'all',
        ...omitBy(filters, isNil),
      },
    },
  ];
};

type FilterType = 'publishers' | 'subjects';

export const queryOmnisearchThinLectureByFilterInfinite = (
  filterType: FilterType,
  { filters, pageSize = 16 }: IQueryLecturesByQueryInfiniteProps
): QueryResourcesInfinite<OmnisearchFilterItem> => {
  return (pageIndex) => {
    const pageNumber = pageIndex + 1;

    return [
      `${OmnisearchLecturesFilter.type}/filters/${filterType}`,
      {
        filter: {
          scope: 'all',
          ...omitBy(filters, isNil),
        },
        params: [
          {
            key: 'page[size]',
            value: pageSize.toString(),
          },
          {
            key: 'page[number]',
            value: pageNumber.toString(),
          },
        ],
      },
    ];
  };
};
